export class Alert {

  constructor(public readonly Message: string, public readonly Level: string) {
  }
}
